import { Box, Checkbox, List, ListItem, ListItemText, TextField, Typography } from "@mui/material";

export default function Question({ question }) {
  
  return (
    <Box>
      <Typography sx={{fontWeight: 'bold'}}>
        {question.question}
      </Typography>
      {question.description && <Typography variant="body2" color="text.secondary">
        {question.description}
      </Typography>}
      {question.type === 'single-choice' && (
        <List>
          {question.options.map((option, index) => (
            <ListItem key={index} disablePadding>
              <Checkbox />
              <ListItemText primary={option} />
            </ListItem>
          ))}
        </List>
      )}
      {question.type === 'multiple-choice' && (
        <List>
          {question.options.map((option, index) => (
            <ListItem key={index} disablePadding>
              <Checkbox />
              <ListItemText primary={option} />
            </ListItem>
          ))}
        </List>
      )}
      {question.type === 'long-text' && (
        <TextField multiline fullWidth minRows={4} variant="outlined" sx={{ mt: 1 }} />
      )}
      {question.type === "text" && (
        <TextField fullWidth variant="outlined" sx={{ "& .MuiInputBase-input": { py: 1 }, mt: 1 }} />
      )}
      {question.type === "number" && (
        <TextField type="number" fullWidth variant="outlined" sx={{ mt: 1 }} />
      )}
    </Box>
  );
}